export const DEFAULT_EMAIL = 'DEFAULT_EMAIL';
export const ANCHOR = 'anchor';
export const SOUNDCLOUD = 'soundcloud';
export const SPREAKER = 'spreaker';
export const OTHER = 'other';
